// export const rootUrl = 'http://localhost/public'
export const rootUrl = 'https://www.xmly.top/api/public'
export const baseURL = rootUrl + '/index.php'
